/* eslint-disable */
import { DEBUG_MODE } from '../config';

export const debug = (...messages: any): void => {
  if (DEBUG_MODE) {
    console.log(...messages);
  }
};
/* eslint-enable */
